import React, { Children } from 'react';
import PropTypes from 'prop-types';

import { Image } from 'components/core/Image';
import { Text } from 'components/core/Text';
import { Paragraph } from 'components/core/Typography';

import './featureList.scss';

export default function FeatureList({ features = [] }) {
	return (
		<ul className="feature-list">
			{Children.toArray(features.map((feature) => (
				<li
					className="feature-item"
				>
					{!!feature.icon &&
						<div className="feature-icon">
							<Image src={feature.icon} role="presentation" />
						</div>
					}
					{!!feature.svg &&
						<div className="feature-svg">
							{React.createElement(feature.svg)}
						</div>
					}
					<div className="feature-content">
						{!!feature.title &&
							<Paragraph className="feature-title">
								{feature.title}
							</Paragraph>
						}
						{!!feature.description &&
							<Text className="feature-description">
								{feature.description}
							</Text>
						}
					</div>
				</li>
			)))}
		</ul>
	);
}

FeatureList.propTypes = {
	features: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			description: PropTypes.string,
			icon: PropTypes.string
		})
	)
};

